import { render, staticRenderFns } from "./AButton.vue?vue&type=template&id=c69624ae&"
import script from "./AButton.vue?vue&type=script&lang=ts&"
export * from "./AButton.vue?vue&type=script&lang=ts&"
import style0 from "./AButton.vue?vue&type=style&index=0&id=c69624ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports